import * as PIXI from 'pixi.js'
import * as filters from 'pixi-filters'

const R = (max=1.0) => Math.random() * max

export default function(demo) {
  // XXX can set stage.filterArea
  demo.shortcuts = [
    {
      char: 'L', keyCode: 76, name: 'layers', run: () => {
        document.querySelector('#layers').style.display =
          (document.querySelector('#layers').style.display == 'block')
          ? 'none' : 'block'
      }
    },
    // XXX: layer bindings doesnt work - wont update the view
    /*{ char: 'D', keyCode: 68, name: 'deleteLayer', run: () => {
        if (demo.selectedLayer <= 0) {
          return
        }

        let layer = demo.app.stage.getChildAt(demo.selectedLayer-1)
        demo.deleteLayer(layer.name)
      }
    },*/
    {
      char: 'R', keyCode: 82, name: 'reload', run: () => location.reload()
    },
    {
      keyCode: 8, name: 'undo', run: () => {
        if (demo.actions.length == 0) {
          return
        }

        let lastAction = demo.actions.pop()

        // affected layer
        let layer = demo.app.stage
        if (lastAction.selectedLayer > 0) {
          layer = demo.app.stage.getChildAt(lastAction.selectedLayer-1)
        }

        if (lastAction.action == 'filter') {
          layer.filters.splice(-1, 1)
        } else if (lastAction.action == 'blendMode') {
          layer.blendMode = lastAction.blendMode
        }
      }
    },
    {
      char: 'E', keyCode: 69, name: 'export', run: () => {
        let url = demo.app.renderer.plugins.extract.base64(
          demo.app.stage, 'image/png')

        let filename = 'c2h-' + Date.now() + '.png'
        let a = document.createElement('a')
    		document.body.append(a)
    		a.download = filename
    		a.href = url
    		a.click()
    		a.remove()﻿﻿
      }
    },
    {
      char: 'H', keyCode: 72, name: 'help', run: () => {
        document.querySelectorAll('#navigoo a')[1].click()
      }
    },
    /*
    {
    //-
      keyCode: 189, name: 'layerDown', run: () => {
        // find index, set zIndex to the one -1
      }
    },
    {
    //+
      keyCode: 187, name: 'layerUp', run: () => {
        // like  - but +1
      }
    },
    */
    // filters ----
    {
      keyCode: 71, name: 'GlitchFilter', run: () => {
        demo.filter(new filters.GlitchFilter({
          slices: 10, offset: 100, fillMode: 2
        }))

        demo.logAction('filter')
      }
    },
    {
      keyCode: 65, name: 'ASCIIFilter', run: () => {
        // XXX should be able to specify layer here
        demo.filter(new filters.AsciiFilter())
        demo.logAction('filter')
      }
    },
    {
      keyCode: 67, name: 'CRTFilter', run: () => {
        demo.filter(new filters.CRTFilter())
        demo.logAction('filter')
      }
    },
    {
      keyCode: 79, name: 'OldFilmFilter', run: () => {
        let o = {
          sepia: R(),
          scratch: 10, scratchDensity: R(), scratchWidth: 5
        }

        demo.filter(new filters.OldFilmFilter(o))
        demo.logAction('filter')
      }
    },
    {
      keyCode: 88, name: 'flipX', run: () => {
        let numLayers = demo.app.stage.children.length
        let layer = demo.app.stage.getChildAt(demo.selectedLayer > 0
          ? demo.selectedLayer-1 : numLayers-1)

        demo.flipX(layer.texture)
        demo.logAction('flipx')
      }
    },
    {
      keyCode: 89, name: 'flipY', run: () => {
        let numLayers = demo.app.stage.children.length
        let layer = demo.app.stage.getChildAt(demo.selectedLayer > 0
          ? demo.selectedLayer-1 : numLayers-1)

        demo.flipY(layer.texture)
        demo.logAction('flipy')
      }
    },
  ]

  document.addEventListener('keydown', e => {
    if (e.target !== document.body) {
      return
    }

    let ord = (c) => c.charCodeAt(0)
    let chr = (code, shiftKey = false) => {
      let _code = code
      // A-Z, a-z
      if (code >= 65 && code <= 90) {
        _code = shiftKey ? code : code+0x20
      }

      return String.fromCharCode(_code)
    }

    let shiftKey = !!e.shiftKey,
        char = chr(e.keyCode, shiftKey)

    console.log('keyDown: ' + e.keyCode, 'char:', char)

    for (let shortcut of demo.shortcuts) {
        if (shortcut.char === char || shortcut.keyCode == e.keyCode) {
          shortcut.run()
        }
    }

    // 0..9 to bring layer to front
    if (e.keyCode >= 48 && e.keyCode <= 57) {
      let layerIdx = parseInt(char)
      //console.log('Layer:', layerIdx)
      let layerSel = (layerIdx == 0) ? 'all' : layerIdx
      demo.setCurrentLayer(layerIdx)
      // select layer (show it), will then be used when running filters, z to reset
    }
  })
}
